import { Component, inject, Input, OnInit, input, contentChildren } from "@angular/core";
import { takeUntil } from "rxjs/operators";

import { UnsubscribeOnDestroy } from '../../classes';
import { MessageService } from '../../services/message.service';
import { CommandButtonComponent } from "./commandbutton/commandbutton.component";


@Component({
    selector: 'pcp-commandbar',
    templateUrl: './pcp-commandbar.component.html',
    styleUrls: ['./pcp-commandbar.component.scss'],
    standalone: true,
    imports: []
})
export class PcpCommandBarComponent extends UnsubscribeOnDestroy implements OnInit {
  private messageService = inject(MessageService);

  get showCommandBar(): boolean {
    return this.commandBarButtons().length > 0;
  }

  readonly commandBarButtons = contentChildren(CommandButtonComponent, { descendants: true });


  readonly displaySidebar = input<boolean>(undefined);
  
  private _isPositionFixed: boolean = false;
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set isPositionFixed(value: boolean) {
    this._isPositionFixed = value;
  }

  get isPositionFixed(): boolean {
    return this.isPositionFixed;
  }

  constructor() {
    super();
  }

  ngOnInit(): void {

  }

  protected hasValue(obj: any) {
    return obj !== undefined && obj !== null;
  }
}
